import { useEffect, useState } from "react";
import SelectCampaign from "./selectCampaign";
import CreateCampaignDetails from "./campaignDetails";
import UploadCampaignImage from "./uploadCampaignImage";
import VerifyCampaign from "./verifyCampaign";
import SubmitCampaign from "./submitCampaign";
import arrow from "../../../assets/icons/goBackArrow.svg";
import Button from "../../../components/button";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../../components/Spinners/Spinner";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { CampaignCreation } from "../../../hooks/local/reducer";
import { showErrorMessage, showSuccessMessage } from "../../../hooks/constants";
import Lottie from "lottie-react";
import animationData from "../../../assets/animations/successAnimation.json"

const CreateCampaign = ({ setPageTitle }) => {

    useEffect(() => {
        setPageTitle("createCampaign");
        document.title = "Start a campaign - Mosquepay";
    }, [setPageTitle]);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loading = useSelector((state) => state.user.loading);

    const [campaignCreatedModal, setCampaignCreatedModal] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);

    const nextPage = () => {
        if (currentPage < 5) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const [selectedCampaignType, setSelectedCampaignType] = useState("CAMP002");

    const [selectedImage, setSelectedImage] = useState(null);
    const [c07Document, setC07Document] = useState(null);
    const [cacDocument, setCacDocument] = useState(null);
    const [referenceLetter, setReferenceLetter] = useState(null);
    const [boardResolution, setBoardResolution] = useState(null);

    const userSessionData = useSelector((state) => state.user.userSession);
    const email = userSessionData.user_details[0].email

    const handleImageSelect = (imageFile) => {
      setSelectedImage(imageFile);
    };
    const handleFormC07Select = (imageFile) => {
      setC07Document(imageFile);
    };
    const handleCacSelect = (imageFile) => {
      setCacDocument(imageFile);
    };
    const handleReferenceLetterSelect = (imageFile) => {
      setReferenceLetter(imageFile);
    };
    const handleBoardResolutionSelect = (imageFile) => {
      setBoardResolution(imageFile);
    };

    const [startDate] = useState(new Date());
    const [endDate, setEndDate] = useState(() => {
      const initialEndDate = new Date();
      initialEndDate.setDate(initialEndDate.getDate() + 90);
      return initialEndDate;
    });

    const campaignStartDate = startDate.toLocaleDateString();
    const campaignEndDate = endDate.toLocaleDateString();
  
    useEffect(() => {
      const newEndDate = new Date(startDate);
      newEndDate.setDate(startDate.getDate() + 90);
      setEndDate(newEndDate);
    }, [startDate]);

    const createCampaignForm = useFormik({
        initialValues: {
            campaign_code: selectedCampaignType,
            start_date: campaignStartDate,
            end_date: campaignEndDate,
            video_url: "",
            goals: "sample goal test",
            email: email,
            title:"",
            campaign_story:"",
            location:"",
            bank_name:"",
            account_number:"",
            bvn:"",
            amount:"",
            images:"",
            co7_form:"",
            cac: "",
            reference_letter:"",
            board_resolution:"",
            needy_category_id: "",
        },
        validationSchema: Yup.object({
          title: Yup.string().required("You can't create a campaign without a title"),
          amount: Yup.string().required("Please provide an amount"),
          campaign_story: Yup.string().required("Tell your story"),
          account_number: Yup.string().required("Provide your acount number "),
          bvn: Yup.string().required("Provide your BVN"),
          needy_category_id: Yup.string().required("Select a category"),
          location: Yup.string().required("Select a category"),
          bank_name: Yup.string().required("Select a bank"),
        }),
        onSubmit: async (values) => {

          const {campaign_code, start_date, end_date, video_url,goals, email, title, campaign_story, location, bank_name, account_number, bvn, amount, needy_category_id} = values;
          let createCampaignData = {campaign_code, start_date, end_date, video_url,goals, email, title, campaign_story, location, bank_name, account_number, bvn, amount,
              images:selectedImage, co7_form:c07Document, cac:cacDocument, reference_letter:referenceLetter, board_resolution:boardResolution,
              needy_category_id};
          const {payload} = await dispatch(CampaignCreation(createCampaignData))
          if(payload.status_code === "0") {
            showSuccessMessage("Campaign created!");
            setCampaignCreatedModal(true);
          }
        }
    })

    return (
      <div>
        <Spinner loading={useSelector((state) => state.user).loading} />

        {currentPage > 1 && (
          <div onClick={prevPage} className="cursor-pointer w-fit">
            <img src={arrow} alt="" className="h-7" />
          </div>
        )}

        <form onSubmit={createCampaignForm.handleSubmit}>
          <div className={currentPage === 1 ? "block" : "hidden"}>
            <SelectCampaign
              selectedCampaignType={createCampaignForm.values.campaign_code}
              onSelectCampaignType={(value) =>
                createCampaignForm.setFieldValue("campaign_code", value)
              }
              onBlur={createCampaignForm.handleBlur}
            />
          </div>

          <div className={currentPage === 2 ? "block" : "hidden"}>
            <CreateCampaignDetails
              campaignTitleName={"title"}
              campaignTitleValue={createCampaignForm.values.title}
              campaignTitleOnChange={createCampaignForm.handleChange}
              campaignTitleOnBlur={createCampaignForm.handleBlur}
              campaignTitleOnError={
                createCampaignForm.touched.title &&
                createCampaignForm.errors.title
                  ? createCampaignForm.errors.title
                  : null
              }
              campaignGoalName={"amount"}
              campaignGoalValue={createCampaignForm.values.amount}
              campaignGoalOnChange={createCampaignForm.handleChange}
              campaignGoalOnBlur={createCampaignForm.handleBlur}
              campaignGoalOnError={
                createCampaignForm.touched.amount &&
                createCampaignForm.errors.amount
                  ? createCampaignForm.errors.amount
                  : null
              }
              categoryName={"needy_category_id"}
              selectedCategory={createCampaignForm.values.needy_category_id}
              onCategoryChange={createCampaignForm.handleChange}
              onCategoryBlur={createCampaignForm.handleBlur}
              onCategoryError={
                createCampaignForm.touched.needy_category_id &&
                createCampaignForm.errors.needy_category_id
                  ? createCampaignForm.errors.needy_category_id
                  : null
              }
              locationName={"location"}
              selectedLocation={createCampaignForm.values.location}
              onLocationChange={createCampaignForm.handleChange}
              onLocationBlur={createCampaignForm.handleBlur}
              onLocationError={
                createCampaignForm.touched.location &&
                createCampaignForm.errors.location
                  ? createCampaignForm.errors.location
                  : null
              }
              campaignStoryName={"campaign_story"}
              campaignStoryValue={createCampaignForm.values.campaign_story}
              campaignStoryOnChange={createCampaignForm.handleChange}
              campaignStoryOnBlur={createCampaignForm.handleBlur}
              campaignStoryOnError={
                createCampaignForm.touched.campaign_story &&
                createCampaignForm.errors.campaign_story
                  ? createCampaignForm.errors.campaign_story
                  : null
              }
            />
          </div>

          <div className={currentPage === 3 ? "block" : "hidden"}>
            <UploadCampaignImage
              videoLinkName={"video_url"}
              videoLinkValue={createCampaignForm.values.video_url}
              videoLinkOnChange={createCampaignForm.handleChange}
              videoLinkOnBlur={createCampaignForm.handleBlur}
              videoLinkOnError={
                createCampaignForm.touched.video_url &&
                createCampaignForm.errors.video_url
                  ? createCampaignForm.errors.video_url
                  : null
              }
              onImageSelect={handleImageSelect}
            />
          </div>

          <div className={currentPage === 4 ? "block" : "hidden"}>
            <VerifyCampaign
              bankName={"bank_name"}
              selectedBank={createCampaignForm.values.bank_name}
              onBankChange={createCampaignForm.handleChange}
              onBankBlur={createCampaignForm.handleBlur}
              onBankError={
                createCampaignForm.touched.bank_name &&
                createCampaignForm.errors.bank_name
                  ? createCampaignForm.errors.bank_name
                  : null
              }
              accountNumberName={"account_number"}
              accountNumberValue={createCampaignForm.values.account_number}
              accountNumberOnChange={createCampaignForm.handleChange}
              accountNumberOnBlur={createCampaignForm.handleBlur}
              accountNumberOnError={
                createCampaignForm.touched.account_number &&
                createCampaignForm.errors.account_number
                  ? createCampaignForm.errors.account_number
                  : null
              }
              bvnName={"bvn"}
              bvnValue={createCampaignForm.values.bvn}
              bvnOnChange={createCampaignForm.handleChange}
              bvnOnBlur={createCampaignForm.handleBlur}
              bvnOnError={
                createCampaignForm.touched.bvn && createCampaignForm.errors.bvn
                  ? createCampaignForm.errors.bvn
                  : null
              }
              onC07FileSelect={handleFormC07Select}
              onCacFileSelect={handleCacSelect}
              onReferenceLetterSelect={handleReferenceLetterSelect}
              onBoardResolutionSelect={handleBoardResolutionSelect}
              hideC07={createCampaignForm.values.campaign_code === "CAMP002" ? "hidden" : "block"}
              hideCAC={createCampaignForm.values.campaign_code === "CAMP002" ? "hidden" : "block"}
              hideBoardResolution={createCampaignForm.values.campaign_code === "CAMP002" ? "hidden" : "block"}
            />
          </div>

          <div className={currentPage === 5 ? "block" : "hidden"}>
            <SubmitCampaign />
          </div>

          {currentPage < 5 && (
            <Button
              buttonRole={"custom"}
              onClick={nextPage}
              buttonText={"Next"}
              otherStyles={"bg-black text-white md:w-1/4"}
            />
          )}

          {currentPage === 5 && (
            <Button
              loading={loading}
              buttonText={"Submit campaign"}
              otherStyles={"bg-black text-white"}
            />
          )}
        </form>

        {campaignCreatedModal && (
          <div className="bg-black/80 fixed top-0 z-50 left-0 right-0 w-full h-full transition-all duration-300 flex items-center justify-center">
            <div className="bg-white rounded-md border border-[#c4c4c424] w-full md:w-1/2 m-4 py-10 px-4 md:px-8 overflow-y-auto">
              <div className="flex justify-center">
                <Lottie
                  animationData={animationData}
                  loop={true}
                  className="w-40"
                />
              </div>
              <p className="font-bold text-center mb-2 mt-6">
                Campaign creation successful!
              </p>
              <p className="text-center">
                Your campaign is now under review for verification and will be approved within 24-48 hours. You'll receive an email once it's approved or if additional details are needed. Thank you for sharing your cause with us!
              </p>
              <div className="flex justify-center mt-6">
                <Link
                  to={"/dashboard/user-campaigns"}
                  className="underline text-brandGreen"
                >
                  My campaigns
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    );
};
 
export default CreateCampaign;
